import React, {useCallback} from 'react'
import {Button} from 'antd'

import {invitesService} from 'services'
import useUserContext from 'components/User/useUserContext'
import TableWithPageHeader from 'components/TableWithPageHeader'
import columns from './columns'

const Customers = () => {
  const {user} = useUserContext()

  return (
    <TableWithPageHeader
      title='Send invites'
      subtitle='Here you can find all users you&apos;ve invited'
      columns={columns}
      service={useCallback(
        page => invitesService.getInvites(user.accountantProfile.uuid, user.accessToken, page),
        [user])}
      extra={<Button key={1} type='primary' onClick={() => alert('Work in progress')}>Invite new user</Button>}
    />
  )
}

export default Customers
